module.exports = __webpack_public_path__ + "static/media/C-100HD_CrossSection.5f68cad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/C-100HD_CrossSection.png
// module id = 474
// module chunks = 0